<template>
  <div class="dashboard">
    <va-card>
      <div class="row row-inside">
        <div class="flex md6">
          <va-button-toggle
            outline
            v-model="showStatus"
            :options="optionsStatus"
          />
        </div>
        <div class="flex xs12 md1 offset--md5">
          <div class="row row-inside">
            <va-button
              class="create-button"
              @click="showCreateFormation = true"
            >
              <va-icon
                size="30px"
                name="fa fa-plus"
              />
            </va-button>
          </div>
        </div>
      </div>
      <div class="row row-inside">
        <div class="flex md12">
          <va-data-table
            class="va-table--hoverable va-table--stripped"
            :fields="fields"
            :data="formations"
            no-data-label="Aucune formation trouvée"
            :per-page="parseInt(perPage)"
            @row-clicked="openFormation"
            clickable
          >
            <template
              slot="entreprises"
              slot-scope="props"
            >

              <p
                v-for="entreprise in props.rowData.entreprises"
                :key="entreprise.id"
              >
                {{ entreprise.nom }}
              </p>
            </template>

            <template
              slot="check"
              slot-scope="props"
            >
             <div class="row align-center checklist-icons">
				<div class="flex">
					<va-popover
                    :message="props.rowData.checklist && props.rowData.checklist.diplomes_envoyes ? 'Diplômes envoyés' : 'Diplômes non envoyés'"
                    placement="top"
                  >
                    <va-icon
                      name="fa fa-circle"
                      :color="props.rowData.checklist && props.rowData.checklist.diplomes_envoyes ? 'success' : '#cccccc'"
                      size="1.2rem"
                    />
                  </va-popover>
				</div>
				<div class="flex">
					<va-popover
                    :message="props.rowData.checklist && props.rowData.checklist.feuille_presence_generee ? 'Feuille de présence générée' : 'Feuille de présence non générée'"
                    placement="top"
                  >
                    <va-icon
                      name="fa fa-file-text"
                      :color="props.rowData.checklist && props.rowData.checklist.feuille_presence_generee ? 'success' : '#cccccc'"
                      size="1.2rem"
                    />
                  </va-popover>
				</div>
				<div class="flex">
					<va-popover
                    :message="props.rowData.capacite_lieu && props.rowData.nb_inscrits > props.rowData.capacite_lieu ? 'Salle complète' : props.rowData.checklist && props.rowData.checklist.salle_reservee ? 'Salle réservée' : 'Salle non réservée'"
                    placement="top"
                  >
                    <va-icon
                      name="fa fa-building"
                      :color="props.rowData.capacite_lieu && props.rowData.nb_inscrits > props.rowData.capacite_lieu ? 'danger' : props.rowData.checklist && props.rowData.checklist.salle_reservee ? 'success' : '#cccccc'"
                      size="1.2rem"
                    />
                  </va-popover>
				</div>
				<div class="flex">
					<va-popover
                    :message="props.rowData.checklist && props.rowData.checklist.feuille_presence_ajoutee ? 'Feuille de présence ajoutée' : 'Feuille de présence non ajoutée'"
                    placement="top"
                  >
                    <va-icon
                      name="fa fa-paperclip"
                      :color="props.rowData.checklist && props.rowData.checklist.feuille_presence_ajoutee ? 'success' : '#cccccc'"
                      size="1.2rem"
                    />
                  </va-popover>
				</div>
				<div class="flex">
					<va-popover
                    :message="props.rowData.checklist && props.rowData.checklist.diplomes_envoyes ? 'Diplômes envoyés' : 'Diplômes non envoyés'"
                    placement="top"
                  >
                    <va-icon
                      name="fa fa-graduation-cap"
                      :color="props.rowData.checklist && props.rowData.checklist.diplomes_envoyes ? 'success' : '#cccccc'"
                      size="1.2rem"
                    />
                  </va-popover>
				</div>
              </div>
            </template>

			<template
			  slot="capacite"
			  slot-scope="props"
			>
			<span 
				v-if="props.rowData.capacite_lieu"
				:style="{ 
					fontWeight: props.rowData.nb_inscrits > props.rowData.capacite_lieu ? 'bold' : 'normal',
					color: props.rowData.nb_inscrits > props.rowData.capacite_lieu ? 'red' : 'inherit'
				}"
			>
				{{ props.rowData.nb_inscrits }} / {{ props.rowData.capacite_lieu }}
			</span>

			</template>

          </va-data-table>
        </div>
      </div>

    </va-card>
    <create-formation
      v-model="showCreateFormation"
      @create="newId => openNewFormation(newId)"
    />
    <fiche-formation
      v-model="showFormation"
      :idformation="idformation"
      @close="closeViewer"
      @deleted="closeViewer"
    />
  </div>
</template>
  
  <script>
import axios from "axios";
import createFormation from "./components/create-formation.vue";
import moment from "moment";
import ficheFormation from "./components/fiche-formation.vue";

moment.locale("fr");

export default {
  name: "liste_formations",
  props: ["idformation"],
  components: {
    "create-formation": createFormation,
    "fiche-formation": ficheFormation,
  },
  data() {
    return {
      formation: null,
      showFormation: false,
      showCreateFormation: false,
      formationsRaw: [],
      perPage: 20,
      optionsStatus: [
        { label: "Toutes", value: "all" },
        { label: "À venir", value: "upcoming" },
        { label: "Passées", value: "past" },
        { label: "Archivées", value: "archived" },
      ],
      showStatus: "all",
    };
  },
  methods: {
	formationStatus(formation) {
		// formation inter and no lieux, grey need to be done
		if (formation.inter == 1 && !formation.idlieu) {
			return {color: "grey", text: "Lieux non défini"};
		} else if (formation.capacite_lieu && formation.nb_inscrits > formation.capacite_lieu) {
			return {color: "red", text: "Complet"};
		} else if (formation.reservation == 1) {
			return {color: "green", text: "Réservé"};
		} else {
			return {color: "orange", text: "Non réservé"};
		}


	},
    closeViewer() {
      this.$router.push({
        name: "liste-formations",
      });
      this.getFormations();
    },
    async getFormations() {
      const response = await axios.get('/api/afpf/formations')

      let rawData = response.data;

      rawData.forEach((formation) => {
        formation.date_fr = moment(formation.date).format("DD/MM/YYYY");

        formation.ftype = formation.inter ? "Inter" : "Intra";
      });
      console.log(rawData);
      this.formationsRaw = rawData;
    },
    openFicheFormation(formation) {
      this.formation = formation
      this.$nextTick(() => {
        this.showFormation = true;
      });

    },
    openNewFormation(idformation) {
      this.getFormations().then(() => {
        console.log("idformation", idformation, this.formations)
        const formation = this.formations.find(f => f.idformation === idformation);
        console.log("formation", formation)
        this.openFormation(formation);
      });
    },
    openFormation(formation) {
      this.$router.push({
        name: "liste-formations",
        params: { idformation: formation.idformation },
      });

    },
  },
  created() {
    this.getFormations();
  },
  mounted() { },
  computed: {
    formations() {
      const today = moment().startOf("day");

      return this.formationsRaw.filter((formation) => {
        switch (this.showStatus) {
          case "upcoming":
            return !moment(formation.date).isBefore(today);
          case "past":
            return moment(formation.date).isBefore(today);
          case "archived":
            // TODO: archiving not implemented yet (all actions done)
            return !!formation.archived;
          default:
            return true;
        }
      });
    },
    fields() {
      return [
        {
          name: "date_fr",
          title: "Date",
          sortField: "date",
          width: "5%",
        },
        {
          name: "type_sf",
          title: "Type de Formation",
          sortField: "type_sf",
          width: "10%",
        },
        {
          name: "ville",
          title: "Lieux",
          sortField: "ville",
          width: "10%",
        },
        {
          name: "__slot:entreprises",
          title: "Entreprise",
          width: "20%",
        },
        {
          name: "nb_inscrits",
          title: "Inscrits",
          sortField: "nb_inscrits",
          width: "5%",
        },
        {
          name: "__slot:capacite",
          title: "Capacité",
          width: "5%",
        },
        {
          name: "ftype",
          title: "Intra/Inter",
          sortField: "ftype",
          width: "5%",
        },
        {
          name: "__slot:check",
          title: "CHECKS",
          width: "15%",
        },
      ]
    }
  },
  watch: {

    idformation: {
      immediate: true,
      handler(newvalue) {

        if (newvalue) {
          console.log("new", newvalue)
          this.openFicheFormation(newvalue);

        } else {
          console.log("test")
          this.showFormation = false;
        }
      },
    }
  },
};
  </script>
  
  <style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}
.dashboard {
  .va-card {
    margin-bottom: 0;
  }
}
.checklist-icons {
  gap: 6px;
  flex-wrap: nowrap;
}
</style>
  